<script setup>
import Picker from '../amsul/pickadate/picker'
import $ from 'jquery';
import timePicker from '../amsul/pickadate/picker.time';
import {useStore} from 'vuex';
import {computed, onMounted} from 'vue';


// eslint-disable-next-line no-undef
const props = defineProps({
	startTime: {
		type: String,
		default: null
	}
});

let reservationTime = null;

const timePickerObject = computed({
	get: () => store.state.reservationForm.timePickerObject,
	set: (value) => store.commit('reservationForm/setSelectedRoom', {timePickerObject: value})
});

const onSetTimePicker = ()=>{
	const pickerList = document.querySelector('.picker__list');
	const newListItem = document.createElement('li');
	newListItem.classList.add('picker__list-item', 'picker__list-item--title');
	newListItem.textContent = 'Horas disponibles';
	pickerList.prepend(newListItem);
	store.commit('reservationForm/setSelectedTime', {selectedTime: timePickerObject.value.get('select', 'HH:i')});
	setRoomsInSlotsTimePicker();
}

const setRoomsInSlotsTimePicker = ()=>{
	console.log('Vamos a añadir las zonas a los picker',store.getters['reservationForm/enableTimeSlots']);
	if(!store.getters['reservationForm/enableTimeSlots']) return;
	console.log('Vamos a añadir las zonas a los picker');
	const timePickerElement = document.getElementById('input-time_root');
	if (!timePickerElement) {
		console.error('No se encontró el elemento del timepicker');
		return;
	}

	const uniqueTimeSlots = new Map();
	const timeSlotElements = timePickerElement.querySelectorAll('.picker__list-item');
	timeSlotElements.forEach(timeSlotElement => {
		const dataPick = timeSlotElement.getAttribute('data-pick');
		if (!uniqueTimeSlots.has(dataPick)) {
			uniqueTimeSlots.set(dataPick, timeSlotElement);
		}
	});


	const customTimeEnable = store.getters['reservationForm/enableTimeSlots'].map(timeSlot => {
		const rooms = store.state.reservationForm.rooms;
		return {time: timeSlot.time, room: rooms.filter(room => room.room_id === timeSlot.roomId)[0].name}
	})

	console.log('customTimeEnable', customTimeEnable.length)

	customTimeEnable.forEach(timeSlot => {
		const [hours, minutes] = timeSlot.time.map(Number);
		const timeInMinutes = hours * 60 + minutes;
		const additionalText = timeSlot.room;

		let timeSlotElement = uniqueTimeSlots.get(timeInMinutes.toString());

		if(timeSlotElement){
			let customTextElement = timeSlotElement.querySelector('.input-time-zone');
			if (!customTextElement) {
				timeSlotElement.innerHTML = "<b>"+ timeSlotElement.innerHTML+"</b>";
				customTextElement = document.createElement('span');
				customTextElement.className = 'input-time-zone';
				timeSlotElement.appendChild(customTextElement);
				customTextElement.textContent += ' | ' + additionalText;
			} else {
				customTextElement.textContent += ', ' + additionalText;
			}
		}


	});
}

const store = useStore();
const isInputTimeDisable = computed(() => store.getters['reservationForm/isInputTimeDisable']);

const selectedTime = computed(() => store.state.reservationForm.selectedTime);

onMounted(() => {
	if (props.startTime) {
		store.commit('reservationForm/setSelectedTime', {selectedTime:props.startTime});
	}

	const settings = {
		format: 'HH:i!h',
		formatSubmit: 'HH:i',
		hiddenName: true,
		clear: 'Borrar',
		onSet: onSetTimePicker
	}
	console.log(settings);
	const picker = Picker($)

	timePicker(picker, $);

	reservationTime = $("#input-time").pickatime(settings);
	store.commit('reservationForm/setTimePickerObjetc', {timePickerObject: reservationTime.pickatime('picker')});
});

</script>

<style>
@import '../amsul/pickadate/pickadate-wewelcom/default.css';
@import '../amsul/pickadate/pickadate-wewelcom/default.time.css';
</style>

<template>
	<div class="input-group">
    <span class="input-group-text">
      <i class="fas fa-clock"></i>
    </span>
		<input :disabled="!isInputTimeDisable" id="input-time" aria-label="" class="form-control rounded-end" placeholder="Hora:" type="text" v-model="selectedTime">
	</div>
</template>

